import { Component } from '@angular/core';

import {AlertController, App, ModalController, NavController, ToastController} from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../providers/user-data';
import {Observable} from "rxjs/Observable";
import {TabsPage} from "../tabs-page/tabs-page";
import {TestPage} from "../test/test";
import {CivilityPage} from "./civility/civility";
import {CvAddForm} from "./cv/form/cvform";
import {AccountSettingsPage} from "./settings/settings";
import {AccountTabsPage} from "./tabs/tabs";
import {CvTabsPage} from "./cv/tabs/tabs";


@Component({
    selector: 'page-account',
    templateUrl: 'account.html'
})
export class AccountPage {
    username: string;
    userInfos: any;
    songs: AngularFireList<any>;
    displayName: string ="";
    displayNote: any ="";
    sessionRef: any;
    userRef: any;

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public afDatabase: AngularFireDatabase,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public app: App
    ) {
        //this.songs = afDatabase.list('/songs');
        //userData.setToken('nova4');

    }
    ionViewWillEnter() {
        //this.userData.checkLoggedIn(this.nav,'AccountPage');
        //this.getUserInfos();
    }
    ionViewDidLoad() {

        this.getUserInfos();
    }
    ionViewWillUnload() {

        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }
    ngAfterViewInit() {

    }
    testAddSong() {
        let prompt = this.alertCtrl.create({
            title: 'Nouvelle expérience',
            message: "Enter a name for this new song you're so keen on adding",
            inputs: [
                {
                    name: 'title',
                    placeholder: 'Title'
                },
            ],
            buttons: [
                {
                    text: 'Cancel',
                    handler: data => {

                    }
                },
                {
                    text: 'Save',
                    handler: data => {
                        const newSongRef = this.songs.push({
                            id: "qsdqs",
                            title: data.title
                        });


                    }
                }
            ]
        });
        prompt.present();
    }
    updatePicture() {

    }

    // Present an alert with the current username populated
    // clicking OK will update the username and display it
    // clicking Cancel will close the alert and do nothing
    changeUsername() {
        let alert = this.alertCtrl.create({
            title: 'Change Username',
            buttons: [
                'Cancel'
            ]
        });
        alert.addInput({
            name: 'username',
            value: this.username,
            placeholder: 'username'
        });
        alert.addButton({
            text: 'Ok',
            handler: (data: any) => {
                this.userData.setUsername(data.username);
                //this.getUsername();
            }
        });

        alert.present();
    }

    getUserInfos() {
        var that = this;
        if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(session => {
                if (session !== null) {
                    that.userRef = that.userData.load().subscribe(user => {
                        let civility = that.userData.get('civility');
                        let ranking = that.userData.get('ranking');
                        if (civility && civility.prenom) {
                            that.displayName = civility.prenom + ' ' + civility.nom
                        }
                        else if(civility && civility.email) {
                            that.displayName = civility.email;
                        }
                        if(ranking && ranking.note)
                        {
                            that.displayNote = ranking.note/5;
                        }
                    });
                }
            });
        }

    }
    changeRanking() {
        if(true || !this.userData.get('ranking') || !this.userData.get('ranking').ok)
        {
            this.nav.push('SelfRankingPage');
        }
    }
    myInformations() {

        this.nav.push(AccountTabsPage, {'tabIndex':0});
        //this.app.getRootNav().push(AccountTabsPage, {'tabIndex':0});
        /*this.nav.setRoot('AccountTabsPage',{
            tabIndex: 0,
        });*/
        /*this.nav.push('AccountTabsPage',{
            tabIndex: 1,
        });*/
    }
    changePassword() {
        //console.log('Clicked to change password');
    }
    changeIdentity() {
        this.nav.push('IdentityPage');
    }
    changeAddress() {
        this.nav.push('AddressPage');
    }
    changeCivility() {
        this.nav.push('CivilityPage');
    }
    changeCv() {
        this.nav.push(CvTabsPage, {'tabIndex':0});
        //this.app.getRootNav().push(CvTabsPage, {'tabIndex':0});
        //this.nav.push('CvPage');
    }
    changeDocuments() {
        this.nav.push('DocumentsPage');
    }
    logout() {
        this.userData.logout();
        this.nav.setRoot('LoginPage');
    }

    support() {
        this.nav.push('SupportPage');
    }
    openSettings(){
        let profileModal = this.modalCtrl.create(AccountSettingsPage);
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Paramètres enregistrés.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts